import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import AdminSecureStorage from '../utils/adminSecureStorage';
import { PATHS } from '../routes/routes';

interface AdminGuardProps {
  children: React.ReactNode;
}

const AdminGuard = ({ children }: AdminGuardProps) => {
  const navigate = useNavigate();

  useEffect(() => {
    // Check if admin token is valid
    if (!AdminSecureStorage.isAdminTokenValid()) {
      console.log('No valid admin token, redirecting to admin login');
      navigate(PATHS.ADMIN_LOGIN);
    }
  }, [navigate]);

  // If no valid token, don't render children (will redirect)
  if (!AdminSecureStorage.isAdminTokenValid()) {
    return null;
  }

  return <>{children}</>;
};

export default AdminGuard;

